/* eslint-disable no-param-reassign */
import axios from 'axios';
// import Vue from 'vue';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';
import max from 'lodash/max';
import cacheAxios from '../../util/cacheAxios';

const zhaopinAxios = axios.create();
const cache = new Map();
cacheAxios(zhaopinAxios, cache);
zhaopinAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

export default {
  state: {
    lang: 'en',
    cities: [],
    provinces: [],
    sectors: [],
    jobFunctions: [],
    jobTrendChartLoading: false,
    jobTrends: [],
    jobGroupCounts: [],
    chartToShow: '2d',
    translation: {},
    jobTrendChartOptions: {
      title: {
        left: 'center',
        top: '1%',
        subtextStyle: {
          fontSize: 14,
          color: '#666',
        },
        textStyle: {
          fontSize: 18,
        },
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '25px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: {
        type: 'line',
        name: 'Job Postings',
      },
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
    },
    compareChartLoading: false,
    compareChartOptions: {
      title: {
        left: 'center',
        top: '1%',
        subtextStyle: {
          fontSize: 14,
          color: '#666',
        },
        textStyle: {
          fontSize: 18,
        },
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      visualMap: {
        show: false,
        calculable: true,
        realtime: false,
        inRange: {
          color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026'],
        },
        outOfRange: {
          colorAlpha: 0,
        },
        // max: linedata[1],
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '25px',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: {
        type: 'bar',
        name: 'Job Postings',
      },
      xAxis: {
        type: 'category',
        data: [],
        splitLine: {
          show: false,
        },
        axisPointer: {
          type: 'shadow',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
      },
    },
    compareChartOptions3d: {
      title: {
        left: 'center',
        top: '1%',
        subtextStyle: {
          fontSize: 14,
          color: '#666',
        },
        textStyle: {
          fontSize: 18,
        },
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      visualMap: {
        show: false,
        calculable: true,
        realtime: false,
        inRange: {
          color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026'],
        },
        outOfRange: {
          colorAlpha: 0,
        },
        // max: linedata[1],
      },
      grid3D: {
        show: true,
        light: {
          main: {
            intensity: 1.2,
            shadow: false,
            beta: -30,
          },
          ambient: {
            intensity: 0.2,
          },
        },
      },
      toolbox: {
        feature: {
          dataView: {
            readOnly: true,
            title: 'Data View',
            optionToContent: (opt) => {
              const series = opt.series;
              const xMap = {};
              opt.xAxis3D[0].data.forEach((x, i) => { xMap[i] = x; });
              const yMap = {};
              opt.yAxis3D[0].data.forEach((y, i) => { yMap[i] = y; });
              let table =
`<table style="text-align:left;padding: 16px;border-collapse: collapse;user-select: all;"><tbody>
  <tr>
    <td style="background-color: #4CAF50;color: white;padding: 12px;border: 1px solid #ddd;"></td>
    <td style="background-color: #4CAF50;color: white;padding: 12px;border: 1px solid #ddd;"></td>
    <td style="background-color: #4CAF50;color: white;padding: 12px;border: 1px solid #ddd;">${series[0].name}</td>
  </tr>`;
              for (let i = 0, l = series[0].data.length; i < l; i += 1) {
                table +=
`<tr>
 <td style="padding: 8px;border: 1px solid #ddd;">${xMap[series[0].data[i].value[0]]}</td>
 <td style="padding: 8px;border: 1px solid #ddd;">${yMap[series[0].data[i].value[1]]}</td>
 <td style="padding: 8px;border: 1px solid #ddd;">${series[0].data[i].name}</td>
</tr>`;
              }
              table += '</tbody></table>';
              return table;
            },
            lang: ['Data View', 'Close', 'Refresh'],
          },
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: [{
        type: 'bar3D',
        name: 'Job Postings',
        data: [],
        // barSize: 0,
        shading: 'realistic',
        emphasis: {
          label: {
            textStyle: {
              fontSize: 20,
              color: '#333',
            },
            formatter: '{b}',
          },
          itemStyle: {
            color: '#333',
          },
        },
      }],
      xAxis3D: {
        name: '',
        type: 'category',
        data: [],
      },
      yAxis3D: {
        name: '',
        type: 'category',
        data: [],
      },
      zAxis3D: {
        name: '',
        type: 'value',
      },
    },
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
    },
    setZhaopinTranslation(state, translation) {
      state.translation = translation;
    },
    setZhaopinCities(state, cities) {
      state.cities = cities;
    },
    setZhaopinProvinces(state, provinces) {
      state.provinces = provinces;
    },
    setZhaopinSectors(state, sectors) {
      state.sectors = sectors;
    },
    setZhaopinJobFunctions(state, jobFunctions) {
      state.jobFunctions = jobFunctions;
    },
    setJobTrends(state, jobTrends) {
      // jobTrends.sort((a, b) => {
      //   if (a.date > b.date) {
      //     return 1;
      //   } else if (a.date > b.date) {
      //     return -1;
      //   }
      //   return 0;
      // });
      state.jobTrends = jobTrends;
    },
    setJobGroupCounts(state, counts) {
      state.jobGroupCounts = sortBy(counts, 'count');
    },
    setJobTrendChartLoading(state, status) {
      state.jobTrendChartLoading = status;
    },
    setCompareChartLoading(state, status) {
      state.compareChartLoading = status;
    },
    plotJobGroupCounts(state, dimension) {
      const xData = [];
      const seriesData = [];
      state.jobGroupCounts.forEach((jt) => {
        let key;
        if (state.lang === 'cn') {
          key = jt.choice;
        } else if (state.lang === 'en') {
          switch (dimension) {
            case 'cityProvince':
              key = state.translation.city[jt.choice] || state.translation.province[jt.choice];
              break;
            case 'sector':
              key = state.translation.sector[jt.choice];
              break;
            case 'jobFunction':
              key = state.translation.subJobFunction[jt.choice];
              break;
            default:
              key = '';
          }
        }
        xData.push(key);
        seriesData.push(jt.count);
      });
      const xAxis = {
        ...state.compareChartOptions.xAxis,
        data: xData,
      };
      const series = {
        ...state.compareChartOptions.series,
        data: seriesData,
      };
      let text;
      if (state.lang === 'cn') {
        text = '职位空缺';
      } else if (state.lang === 'en') {
        text = 'Job Vacancies';
      }
      state.compareChartOptions = {
        ...state.compareChartOptions,
        title: { text },
        xAxis,
        series,
        visualMap: {
          ...state.compareChartOptions.visualMap,
          max: max(seriesData),
        },
      };
      state.chartToShow = '2d';
      state.compareChartLoading = false;
    },
    plotJobGroupCounts2d(state, dimensions) {
      let xData = [];
      let yData = [];
      const seriesData = [];

      state.jobGroupCounts.forEach((jt) => {
        yData.push(jt.choice1);
        xData.push(jt.choice2);
      });
      const counts = [];
      xData = uniq(xData);
      yData = uniq(yData);
      state.jobGroupCounts.forEach((jt) => {
        const x = xData.indexOf(jt.choice2);
        const y = yData.indexOf(jt.choice1);
        counts.push(jt.count);
        if (state.lang === 'cn') {
          seriesData.push({
            name: `${jt.choice1} - ${jt.choice2} (${jt.count})`,
            value: [x, y, jt.count],
          });
        } else if (state.lang === 'en') {
          seriesData.push({
            name: jt.count,
            value: [x, y, jt.count],
          });
        }
      });
      if (state.lang === 'en') {
        xData = xData.map((k) => {
          switch (dimensions[1]) {
            case 'cityProvince':
              return state.translation.city[k] || state.translation.province[k];
            case 'sector':
              return state.translation.sector[k];
            case 'jobFunction':
              return state.translation.subJobFunction[k];
            default:
              return '';
          }
        });
        yData = yData.map((k) => {
          switch (dimensions[0]) {
            case 'cityProvince':
              return state.translation.city[k] || state.translation.province[k];
            case 'sector':
              return state.translation.sector[k];
            case 'jobFunction':
              return state.translation.subJobFunction[k];
            default:
              return '';
          }
        });
      }

      const xAxis3D = {
        ...state.compareChartOptions3d.xAxis3D,
        data: xData,
        name: dimensions[1],
      };
      const yAxis3D = {
        ...state.compareChartOptions3d.yAxis3D,
        data: yData,
        name: dimensions[0],
      };
      const series = [{
        ...state.compareChartOptions3d.series[0],
        data: seriesData,
      }];
      let text;
      if (state.lang === 'cn') {
        text = '职位空缺';
      } else if (state.lang === 'en') {
        text = 'Job Vacancies';
      }
      state.compareChartOptions3d = {
        ...state.compareChartOptions3d,
        title: { text },
        xAxis3D,
        yAxis3D,
        series,
        visualMap: {
          ...state.compareChartOptions3d.visualMap,
          max: max(counts),
        },
      };
      state.chartToShow = '3d';
      state.compareChartLoading = false;
    },
    plotJobTrend(state, { city, sector, jobFunction }) {
      const textArray = [];
      let title = '';
      switch (state.lang) {
        case 'cn':
          if (city.length === 2) {
            textArray.push(city[1]);
          }
          if (sector.length > 0) {
            textArray.push(sector[sector.length - 1]);
          }
          if (jobFunction.length > 0) {
            textArray.push(jobFunction[jobFunction.length - 1]);
          }
          title = {
            ...state.jobTrendChartOptions.title,
            subtext: '职位空缺',
            text: textArray.join(' - '),
          };
          break;
        case 'en':
          if (city.length === 2) {
            if (city[0] === 'cities') {
              textArray.push(state.translation.city[city[1]]);
            } else if (city[0] === 'provinces') {
              textArray.push(state.translation.province[city[1]]);
            }
          }
          if (sector.length > 0) {
            if (sector.length === 1) {
              textArray.push(state.translation.sector[sector[0]]);
            } else if (sector.length === 2) {
              textArray.push(state.translation.industry[sector[1]]);
            }
          }
          if (jobFunction.length > 0) {
            if (jobFunction.length === 1) {
              textArray.push(
                state.translation.jobFunction[jobFunction[0]]);
            } else if (jobFunction.length === 2) {
              textArray.push(
                state.translation.subJobFunction[jobFunction[1]]);
            } else if (jobFunction.length === 3) {
              textArray.push(
                state.translation.subSubJobFunction[jobFunction[2]]);
            }
          }
          title = {
            ...state.jobTrendChartOptions.title,
            subtext: 'Job Vacancies',
            text: textArray.join(' - '),
          };
          break;
        default:
      }

      const xData = [];
      const seriesData = [];
      state.jobTrends.forEach((jt) => {
        const key = jt.date;
        xData.push(key);
        seriesData.push(jt.count);
      });
      const xAxis = {
        ...state.jobTrendChartOptions.xAxis,
        data: xData,
      };
      const series = {
        ...state.jobTrendChartOptions.series,
        data: seriesData,
      };

      state.jobTrendChartOptions = {
        ...state.jobTrendChartOptions,
        title,
        xAxis,
        series,
      };
      state.jobTrendChartLoading = false;
    },
  },
  actions: {
    allZhaopinCitiesAndProvinces({ commit }) {
      zhaopinAxios.get('/aims/api/zhaopin/citiesProvinces').then((res) => {
        if (res.data) {
          commit('setZhaopinCities', res.data.cities);
          commit('setZhaopinProvinces', res.data.provinces);
        }
      });
    },
    getZhaopinTranslation({ commit }) {
      zhaopinAxios.get('/aims/api/zhaopin/translation').then((res) => {
        if (res.data) {
          commit('setZhaopinTranslation', res.data);
        }
      });
    },
    allZhaopinSectors({ commit }) {
      zhaopinAxios.get('/aims/api/zhaopin/sectors').then((res) => {
        if (res.data) {
          commit('setZhaopinSectors', res.data);
        }
      });
    },
    allZhaopinJobFunctions({ commit }) {
      zhaopinAxios.get('/aims/api/zhaopin/jobFunctions').then((res) => {
        if (res.data) {
          commit('setZhaopinJobFunctions', res.data);
        }
      });
    },
    queryZhaopinJobTrend({ commit }, query) {
      commit('setJobTrendChartLoading', true);
      zhaopinAxios.post('/aims/api/zhaopin/jobTrends', query, {
        cache: true,
        cacheKey: query,
      }).then((res) => {
        if (res.data) {
          commit('setJobTrends', res.data);
          commit('plotJobTrend', query);
        }
      });
    },
    queryZhaopinJobs1d({ commit }, query) {
      commit('setCompareChartLoading', true);
      if (query.choices.length === 0) {
        commit('setJobGroupCounts', []);
        commit('plotJobGroupCounts', query.dimension);
        return;
      }
      query.choices.sort();
      zhaopinAxios.post('/aims/api/zhaopin/jobs1d', query, {
        cache: true,
        cacheKey: query,
      }).then((res) => {
        if (res.data) {
          commit('setJobGroupCounts', res.data);
          commit('plotJobGroupCounts', query.dimension);
        }
      });
    },
    queryZhaopinJobs2d({ commit }, query) {
      commit('setCompareChartLoading', true);
      if (query.choices.length === 0) {
        commit('setJobGroupCounts', []);
        commit('plotJobGroupCounts2d', query.dimensions);
        return;
      }
      zhaopinAxios.post('/aims/api/zhaopin/jobs2d', query, {
        cache: true,
        cacheKey: query,
      }).then((res) => {
        if (res.data) {
          commit('setJobGroupCounts', res.data);
          commit('plotJobGroupCounts2d', query.dimensions);
        }
      });
    },
  },
  getters: {
    zhaopinCitiesTree(state) {
      if (!state.translation.city || !state.translation.province) {
        return [];
      }
      if (state.lang === 'cn') {
        return [{
          value: 'cities',
          label: '主要城市',
          children: state.cities.map(city => ({ value: city, label: city })),
        }, {
          value: 'provinces',
          label: '省份',
          children: state.provinces.map(p => ({ value: p, label: p })),
        }];
      } else if (state.lang === 'en') {
        return [{
          value: 'cities',
          label: 'Main Cities',
          children: state.cities.map(city =>
            ({ value: city, label: state.translation.city[city] })),
        }, {
          value: 'provinces',
          label: 'Provinces',
          children: state.provinces.map(p =>
            ({ value: p, label: state.translation.province[p] })),
        }];
      }
      return [];
    },
    zhaopinSectorsTree(state) {
      if (!state.translation.sector || !state.translation.industry) {
        return [];
      }
      if (state.lang === 'cn') {
        return state.sectors.map(sector => ({
          value: sector.sector,
          label: sector.sector,
          children: sector.industries.map(ind => ({
            value: ind,
            label: ind,
          })),
        }));
      } else if (state.lang === 'en') {
        return state.sectors.map(sector => ({
          value: sector.sector,
          label: state.translation.sector[sector.sector],
          children: sector.industries.map(ind => ({
            value: ind,
            label: state.translation.industry[ind],
          })),
        }));
      }
      return [];
    },
    zhaopinJobFunctionsTree(state) {
      if (!state.translation.jobFunction || !state.translation.subJobFunction
        || !state.translation.subSubJobFunction) {
        return [];
      }
      if (state.lang === 'cn') {
        return state.jobFunctions.map(f => ({
          value: f.jobFunction,
          label: f.jobFunction,
          children: f.subJobFunctions.map(s => ({
            value: s.subJobFunction,
            label: s.subJobFunction,
            children: s.subSubJobFunctions.map(ss => ({
              value: ss,
              label: ss,
            })),
          })),
        }));
      } else if (state.lang === 'en') {
        return state.jobFunctions.map(f => ({
          value: f.jobFunction,
          label: state.translation.jobFunction[f.jobFunction],
          children: f.subJobFunctions.map(s => ({
            value: s.subJobFunction,
            label: state.translation.subJobFunction[s.subJobFunction],
            children: s.subSubJobFunctions.map(ss => ({
              value: ss,
              label: state.translation.subSubJobFunction[ss],
            })),
          })),
        }));
      }
      return [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/zhaopinModule.js